<div
  #menuDiv
  class="tw-fixed tw-bottom-0 tw-left-0 tw-right-0 tw-z-50 tw-pointer-events-none tw-flex tw-flex-col tw-items-center tw-w-full"
>
  <!-- Floating pill: first pinnedCount items + a detached "More" button. Items are real links
       and More a real button: a routerLink/(click) on a <nav> ignores Enter, and More wasn't
       focusable at all. -->
  <nav
    data-primary-nav="horizontal"
    class="tw-pointer-events-auto tw-flex tw-items-center tw-gap-2 tw-mb-[calc(1rem+var(--safe-area-bottom,0px))]"
    [class.tw-hidden]="menuItems().length === 0"
    [attr.aria-label]="'primaryNavigation' | i18n"
  >
    <div
      class="tw-relative tw-grid tw-auto-cols-[70px] tw-grid-flow-col tw-p-1 tw-shrink tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-backdrop-blur-[3px] tw-bg-white/40 dark:tw-bg-white/[0.06] tw-shadow-elevation-glass-panel"
    >
      @for (item of menuItems(); track item.key; let i = $index) {
        @if (i < pinnedCount) {
          <app-signal-glow-wrapper
            adjustmentClasses="tw-rounded-full"
            [isSignal]="isSignal(item)"
            *appRoleScope="item.roleScope"
          >
            <a
              class="tw-flex tw-h-full tw-min-w-[70px] tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-p-1 hover:tw-no-underline"
              [ngClass]="{
                'tw-bg-[rgba(185,187,198,0.4)] dark:tw-bg-white/[0.12]': selectedKey() === item.key,
              }"
              [routerLink]="item.routerLink"
              (click)="onPinnedItemClick($event, item.key)"
              [routerLinkActive]="'tw-no-underline'"
              ariaCurrentWhenActive="page"
              [attr.data-testid]="'app-menu-' + item.key"
              (isActiveChange)="onIsActiveChange($event, item.key)"
            >
              <svg
                class="tw-h-6 tw-w-6"
                [ngClass]="
                  selectedKey() === item.key ? 'tw-text-dt-text-action' : 'tw-text-dt-text-tertiary'
                "
              >
                <use [attr.xlink:href]="'images/sprite.svg#' + getSelectedIcon(item)" />
              </svg>
              <span
                class="tw-text-[11px] tw-whitespace-nowrap"
                [ngClass]="[
                  selectedKey() === item.key
                    ? 'tw-font-semibold tw-text-dt-text-action'
                    : 'tw-font-medium tw-text-teal-900 dark:tw-text-dt-text-secondary',
                  item.key === GlossRoutes.Account
                    ? 'tw-tracking-[-0.33px]'
                    : 'tw-tracking-[0.055px]',
                ]"
                >{{ item.label | i18n }}</span
              >
            </a>
          </app-signal-glow-wrapper>
        }
      }
    </div>

    @if (hasOverflowItems) {
      <div
        class="tw-relative tw-flex tw-p-1 tw-w-[68px] tw-shrink-0 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-backdrop-blur-[3px] tw-bg-white/40 dark:tw-bg-white/[0.06] tw-shadow-elevation-glass-panel"
      >
        <button
          type="button"
          class="tw-flex tw-h-full tw-w-[60px] tw-flex-col tw-items-center tw-justify-center tw-rounded-full tw-p-1"
          [ngClass]="{
            'tw-bg-[rgba(185,187,198,0.4)] dark:tw-bg-white/[0.12]':
              showMoreOverview() || isHiddenItemSelected(),
          }"
          (click)="openMoreOverview()"
          (contextmenu)="$event.preventDefault()"
          [attr.aria-expanded]="showMoreOverview()"
          data-testid="app-menu-more"
        >
          <svg class="tw-h-6 tw-w-6">
            <use
              [attr.xlink:href]="
                'images/sprite.svg#more' +
                (showMoreOverview() || isHiddenItemSelected() ? '-selected' : '')
              "
            />
          </svg>
          <span
            class="tw-text-[11px] tw-tracking-[0.055px] tw-whitespace-nowrap"
            [ngClass]="
              showMoreOverview() || isHiddenItemSelected()
                ? 'tw-font-semibold tw-text-dt-text-action'
                : 'tw-font-medium tw-text-teal-900 dark:tw-text-dt-text-secondary'
            "
            >{{ "more" | i18n }}</span
          >
        </button>
      </div>
    }
  </nav>
</div>

@if (showMoreOverview()) {
  <app-more-overview
    [pinnedItems]="menuItems().slice(0, pinnedCount)"
    [otherItems]="menuItems().slice(pinnedCount)"
    [tools]="moreTools"
    (toolSelected)="onToolSelected($event)"
    (itemSelected)="onOverviewItemSelected($event)"
    (monthlySummarySelected)="onMonthlySummarySelected()"
    (editNavigation)="onEditNavigationRequested()"
    (closed)="onOverviewClosed()"
  ></app-more-overview>
}

@if (showEditNavigation()) {
  <app-edit-navigation
    [pinnedItems]="menuItems().slice(0, pinnedCount)"
    [otherItems]="menuItems().slice(pinnedCount)"
    [defaultOrder]="eligibleItems"
    (saved)="onEditNavigationSaved($event)"
    (cancelled)="onEditNavigationCancelled()"
  ></app-edit-navigation>
}
